import Menu from "@material-ui/icons/PictureAsPdf";
import { data } from "../../../../asset/json/literature";
import { howToData } from "../../../../asset/json/literature";
import logo from "../../../../asset/image/MaskGroup.svg";
import "./literature.scss";
import { Container } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { useState } from "react";
import { Fade, Zoom, Slide, Bounce } from "react-reveal";
import { Helmet } from "react-helmet";

const useStyles = makeStyles({
  root: {
    width: 180,
    borderRadius: 10,
    marginBottom: "4%",
    fontFamily: "Montserrat",
  },
  media: {
    height: 140,
  },
  font: {
    fontFamily: "Montserrat",
  },
});
const Literature = () => {
  const [dataa, setdataa] = useState(data);
  const [active, setactive] = useState("CloudInfluence");
  const [view, setview] = useState("CloudInfluence");

  const classes = useStyles();
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Resource Literature page" />
        <meta
          name="description"
          content="CloudSocial provides all the literature resources which guide you to succeed in the CloudSocial media marketing platform. Check out our learning materials."
        />
        <title>Literature - Social Media Resources by CloudSocial</title>
        <link
          rel="canonical"
          href="https://www.cloudsocial.io/resources/literature"
        />
      </Helmet>
      <Container>
        <div className="guide-card">
          <Zoom cascade>
            {dataa.map((data) => {
              return (
                <a href={data.url} target="_blank" rel="noreferrer">
                  <Card className={classes.root}>
                    <CardActionArea>
                      <CardMedia
                        className={classes.media}
                        image={data.image}
                        title="Contemplative Reptile"
                      />
                      <CardContent style={{ height: "100" }}>
                        <Typography gutterBottom className={classes.font}>
                          {data.title}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <div className="click-card">
                        <div className="click"></div>
                        <div>
                          <Button
                            href={data.url}
                            target="_blank"
                            size="small"
                            color="primary"
                            className={classes.font}
                          >
                            view
                            <Menu />
                          </Button>
                        </div>
                      </div>
                    </CardActions>
                  </Card>
                </a>
              );
            })}
          </Zoom>
        </div>
        <h1 className="title-social">How to</h1>
        <div className="guide-card">
          <Zoom cascade>
            {howToData.map((data) => {
              return (
                <a href={data.url} target="_blank" rel="noopener noreferrer">
                  <Card className={classes.root}>
                    <CardActionArea>
                      <CardMedia
                        className={classes.media}
                        image={data.image}
                        title="Contemplative Reptile"
                      />
                      <CardContent style={{ height: "100" }}>
                        <Typography gutterBottom>{data.title}</Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <div className="click-card">
                        <div className="click"></div>
                        <div>
                          <Button
                            href={data.url}
                            target="_blank"
                            size="small"
                            color="primary"
                          >
                            view
                            <Menu />
                          </Button>
                        </div>
                      </div>
                    </CardActions>
                  </Card>
                </a>
              );
            })}
          </Zoom>
        </div>
      </Container>
    </div>
  );
};

export default Literature;
